export const createPopover = (el, options = {}) => {
    const whiteList = $.fn.popover.Constructor.Default.whiteList;
    whiteList.table = [];
    whiteList.tr = [];
    whiteList.td = [];
    whiteList.th = [];
    whiteList.tbody = [];
    whiteList.thead = [];

    options.container = options.container ?? 'body';
    options.width = options.width ?? el.data('width');

    if (options.width) {
        options.template = `
            <div
                class="popover"
                role="tooltip"
                style="
                    width: ${options.width}px;
                    min-width: ${options.width}px;
                    max-width: ${options.width}px
                "
            >
                <div class="arrow"></div>
                <h3 class="popover-header"></h3>
                <div class="popover-body"></div>
            </div>
        `;
    }

    el.popover(options);

    // This is necessary in order for options.width to be respected. This is
    // also necessary when used in the context of a vue directive so that
    // changes to options.title are reflected in the DOM after an update.
    Object.assign(el.data('bs.popover').config, options);
};
